export default {
    plans() {
        return axios.get("/api/hpc/plans");
    },
    payPlan(data) {
        return axios.post("/api/hpc/plans/" + data.plan + "/payment", data);
    },
};
